import React from 'react';

import { IconProps } from './type';

const ArrowExpandIcon: React.FC<IconProps> = ({ className = '', size = 20, ...props }) => (
  <svg
    height={size}
    viewBox="0 -.5 17 17"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd" transform="translate(1)">
      <path d="m15.196.083h-3.867c-.38 0-.688.31-.688.69l1.588 1.594-1.917 1.917c-.192.192-.288.443-.288.695s.096.503.288.695c.383.384 1.006.384 1.391 0l1.914-1.915 1.579 1.585c.38 0 .687-.31.687-.69v-3.881c0-.38-.307-.69-.687-.69z" />
      <path d="m15.192 10.645-1.619 1.612-1.952-1.952c-.385-.385-1.007-.385-1.392 0-.384.384-.384 1.006 0 1.39l1.951 1.95-1.56 1.554c0 .38.309.687.69.687h3.881c.381 0 .69-.307.69-.687v-3.866c.002-.382-.308-.688-.689-.688z" />
      <path d="m3.758 2.359 1.584-1.579c0-.38-.311-.687-.691-.687h-3.88c-.381 0-.69.307-.69.687v3.866c0 .381.31.688.69.688l1.595-1.587 1.969 1.968c.192.193.443.289.694.289.253 0 .503-.096.696-.289.383-.383.383-1.006 0-1.389z" />
      <path d="m4.951 9.645-2.59 2.59-1.594-1.601c-.379 0-.688.31-.688.69v3.881c0 .381.309.69.688.69h3.867c.379 0 .687-.31.687-.69l-1.571-1.578 2.592-2.592c.385-.385.385-1.006 0-1.391-.383-.383-1.006-.383-1.391.001z" />
    </g>
  </svg>
);

export default ArrowExpandIcon;
